<template>
  <!-- <div class="d-flex mt-2 sticky-box justify-space-between"> -->
  <div class="d-flex mt-2 sticky-box justify-center">
    <SaveOfferButton :disabled="isSaveDisabled" @onSaveClicked="saveOffer" />
    <!-- <ResetOfferButton @onResetClicked="resetOffer" /> -->
  </div>
</template>

<script>
import SaveOfferButton from '@/components/buttons/SaveOfferButton'
// import ResetOfferButton from '@/components/buttons/ResetOfferButton'

export default {
  name: 'SaveAndResetOfferButtons',
  components: {
    SaveOfferButton,
    // ResetOfferButton,
  },
  props: ['isSaveDisabled'],
  methods: {
    saveOffer() {
      this.$emit('onSaveClicked')
    },
    resetOffer() {
      this.$emit('onResetClicked')
    },
  },
}
</script>
